import { http } from '@shared';
import { IOrderGetPayUrl } from '@root/types/order';

// 创建订单
const getPayUrl = (data: IOrderGetPayUrl) => {
  return http.request({
    url: '/payGateway/getPayUrl',
    method: 'POST',
    data,
  });
};

// 查询支付方式列表
const getPayMethodList = () => {
  return http.request({
    url: '/payGateway/payModeList',
    method: 'GET',
  });
};

export { getPayUrl, getPayMethodList };
